module.exports = __webpack_public_path__ + "static/media/bean.477299ea.png";